"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var React = __importStar(require("react"));
var grid_1 = require("@rebass/grid");
var react_genie_1 = require("react-genie");
var styled_components_1 = __importDefault(require("styled-components"));
var Header_1 = require("../Header");
var BackgroundImage_1 = require("./BackgroundImage");
var TextCaptionWrapper_1 = require("./TextCaptionWrapper");
var Caption_1 = require("./Caption");
var lauterbad_common_1 = require("@eimerreis/lauterbad-common");
var LinkWrapper_1 = require("../LinkWrapper");
var react_1 = require("react");
exports.MetroTileWrapper = styled_components_1["default"](grid_1.Box)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    position: relative;\n    overflow: hidden;\n    height: 50vh;\n    cursor: pointer;\n\n    &:after {\n        display: block;\n        position: relative;\n        background-image: linear-gradient(180deg,transparent 0,rgba(0,0,0,.6));\n        margin-top: -150px;\n        height: 150px;\n        width: 100%;\n        content: \"\";\n        z-index: 1;\n    }\n"], ["\n    position: relative;\n    overflow: hidden;\n    height: 50vh;\n    cursor: pointer;\n\n    &:after {\n        display: block;\n        position: relative;\n        background-image: linear-gradient(180deg,transparent 0,rgba(0,0,0,.6));\n        margin-top: -150px;\n        height: 150px;\n        width: 100%;\n        content: \"\";\n        z-index: 1;\n    }\n"])));
var ExtendedCaption = styled_components_1["default"](Caption_1.Caption)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    ", ":hover & {\n        background-position: 0 100%;\n    }\n"], ["\n    ", ":hover & {\n        background-position: 0 100%;\n    }\n"])), exports.MetroTileWrapper);
exports.FullMetroTile = function (props) {
    var blok = props.blok;
    var _a = react_1.useState("1920x0"), transformation = _a[0], setTransformation = _a[1];
    react_1.useEffect(function () {
        var width = lauterbad_common_1.WindowService.GetWindowDimensions().width;
        setTransformation(width.toFixed(0) + "x0");
    });
    return (React.createElement(exports.MetroTileWrapper, { width: [1] },
        React.createElement(LinkWrapper_1.LinkWrapper, { internal: lauterbad_common_1.IsInternalLink(blok.link.cached_url), link: blok.link.cached_url },
            React.createElement(BackgroundImage_1.BackgroundImage, { filters: "filters:quality(90)", size: transformation, src: blok.image }),
            React.createElement(TextCaptionWrapper_1.TextCaptionWrapper, null,
                props.blok.caption ?
                    React.createElement(ExtendedCaption, null, props.blok.caption)
                    : React.createElement(React.Fragment, null),
                React.createElement(react_genie_1.Reveal, { animation: react_genie_1.Animation.FadeIn },
                    React.createElement(Header_1.Header, null, props.blok.text))))));
};
var templateObject_1, templateObject_2;
